<template>
  <div>
    <select-component
      v-if='isSelect'
      :haveSelected='haveSelected'
      @selectWarehouse='v => { $emit("selectWarehouse", v) }'
      @addWarehouseClick='$emit("addWarehouseClick")'
    />
    <add-component
      v-else
      @cancelWarehouseClick='$emit("cancelWarehouseClick")'
      @selectWarehouse='v => { $emit("selectWarehouse", v) }'
    />
  </div>
</template>

<script>
import selectComponent from './select'
import addComponent from './add'
export default {
  name: 'syncStep1',
  props: {
    isSelect: {
      type: Boolean,
      required: true,
      default: true
    },
    haveSelected: {
      required: true
    }
  },
  components: {
    selectComponent,
    addComponent
  }
}
</script>
